
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm1.315 11.468L16.014 5H19l-2.7 6.468h-2.985zm-5.63-3.294H5l3.007 7.105L6.917 18h2.716l4.075-9.826h-2.645l-1.68 4.216-1.698-4.216zm6.42 7.266c.917 0 1.661-.747 1.661-1.668 0-.921-.744-1.668-1.662-1.668-.918 0-1.662.747-1.662 1.668 0 .921.744 1.668 1.662 1.668z","fill":"currentColor"}})])
          )
        }
      }
    